import $ from 'jquery';

export  const footer = (id) => {
    $(id).css('min-height', 0);
    $(id).css('min-height', (
        $(document).height()
        - $('.header-sec').height()
        - $('.foot-size').height()

    ));
    // alert($(document).height() +'-'+ $('.dashHeader').height() +'-'+ $('.footer-section').height());
}

 


// .register-content